import getStudentSpecialityInfoList from './getStudentSpecialityInfoList';
import getStudentSpecialityAwardList from './getStudentSpecialityAwardList';
import outputStudentSpecialityInfoExcel from './outputStudentSpecialityInfoExcel';
import outputStudentSpecialityAwardExcel from './outputStudentSpecialityAwardExcel';
import getStudentSpecialityTypeList from './getStudentSpecialityTypeList';
import getCampusClasses from './getCampusClasses';
export default {
  getStudentSpecialityInfoList,
  outputStudentSpecialityInfoExcel,
  getStudentSpecialityTypeList,
  getCampusClasses,
  outputStudentSpecialityAwardExcel,
  getStudentSpecialityAwardList,
};


// WEBPACK FOOTER //
// ./src/api/students/index.ts